import type { IntlShape } from 'react-intl';

export interface CertificatePurchaseMessages {
  cardDetailsRequired: string;
  bothCardsRequired: string;
  splitAmountsMismatch: string;
  multicardSplitMinAmount: string;
  createPaymentMethodFailed: string;
  createPaymentMethodCard1Failed: string;
  createPaymentMethodCard2Failed: string;
  downPaymentRequired: string;
  downPaymentSplitMismatch: string;
  purchaseFailed: string;
}

export function buildCertificatePurchaseMessages(intl: IntlShape): CertificatePurchaseMessages {
  return {
    cardDetailsRequired: intl.formatMessage({ id: 'certificates.purchase.error.cardRequired' }),
    bothCardsRequired: intl.formatMessage({ id: 'certificates.purchase.error.bothCardsRequired' }),
    splitAmountsMismatch: intl.formatMessage({ id: 'certificates.purchase.error.splitTotal' }),
    multicardSplitMinAmount: intl.formatMessage({
      id: 'certificates.payment.validation.multicardMinAmount',
    }),
    createPaymentMethodFailed: intl.formatMessage({
      id: 'certificates.purchase.error.paymentMethod',
    }),
    createPaymentMethodCard1Failed: intl.formatMessage({
      id: 'certificates.purchase.error.paymentMethodCard1',
    }),
    createPaymentMethodCard2Failed: intl.formatMessage({
      id: 'certificates.purchase.error.paymentMethodCard2',
    }),
    downPaymentRequired: intl.formatMessage({
      id: 'certificates.purchase.error.downPaymentRequired',
    }),
    downPaymentSplitMismatch: intl.formatMessage({
      id: 'certificates.purchase.error.downSplitTotal',
    }),
    purchaseFailed: intl.formatMessage({ id: 'certificates.purchase.error.failed' }),
  };
}
